import { hasLoaded } from './../utility/hasLoaded'

export default function init() {
	const el = document.querySelector('.hero')
	if (!el) return
	const images = [...el.querySelectorAll('img')]
	raceDelay(docReady, 1000, () => {
		raceDelay(
			fn => hasLoaded(images, fn), 1000, () => {
				el.classList.add('hero--loaded-stg1')
				setTimeout(() => el.classList.add('hero--loaded-stg2'), 800)
				setTimeout(() => el.classList.add('hero--loaded-stg3'), 1200)
			}
		)
	})
}

function raceDelay(fn, delay, callback) {
	let hasRun = false
	const done = () => {
		if (!hasRun) {
			hasRun = true
			callback()
		}
	}
	setTimeout(done, delay)
	fn(done)
}

function docReady(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
        setTimeout(fn, 1)
    } else {
        document.addEventListener("DOMContentLoaded", fn)
    }
}